import { TextField, InputLabel, Button, Box } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import React, { useEffect, useState } from 'react';
import './login.css';
import { useForm } from 'react-hook-form';
import { json, useNavigate, useSearchParams } from 'react-router-dom';
import ApiService from '../../functions/apiService';
import { useSelector } from 'react-redux';
import { reloadUserData } from '../../context/AuthContext';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import TextFieldComponent from '../../components/TextField/TextField';
import { Link } from "react-router-dom";
import { toast } from 'react-toastify';

export default function Login() {
  let navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [loadingToken, setLoadingToken] = useState(false);
  const [waitCssImg, setWaitCssImg] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const tokenUrl = searchParams.get('token');
  const [department, setDepartment] = useState('');
  const [tempDepartment, setTempDepartment] = useState('');

  const { register, formState: { errors }, handleSubmit, setError, setValue } = useForm({
    defaultValues: {
      department: localStorage.getItem('department'),
    }
  });

  const togglePasswordVisibility = () => setShowPassword((show) => !show);

  const removeDepartment = () => {
    setValue("department", "")
    setDepartment('');
    localStorage.removeItem('department');
  }

  const myToken = useSelector((state) => state.firebaseReducer.Token);

  const onSubmit = (d) => {
    if (myToken && myToken !== '') {
      d['FCM_Token'] = myToken;
      d['DeviceId'] = myToken;
    }
    setLoading(true);
    ApiService.post('/login', d).then((data) => {
      setLoading(false);
      localStorage.setItem("department", d.department);
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));
      localStorage.setItem("permission", JSON.stringify(data.permission));
      localStorage.setItem("pages", JSON.stringify(data.allowedPages));
      localStorage.setItem("pagesName", JSON.stringify(data.PagesNames));
      localStorage.setItem("is_dn_deparment", JSON.stringify(data.is_dn_deparment));
			toast.success("Login Successful")
      navigate(data?.password_expired == true ? '/firehouse/change-password' : '/firehouse/calendar');
    }).catch(({ data }) => {
      setError('password', { type: 'manual', message: data.message });
      setLoading(false);
    });
  };

  useEffect(() => {
    const storedDepartment = localStorage.getItem('department');
    if (storedDepartment) {
      setDepartment(storedDepartment);
    }
    if (tokenUrl) {
      setLoadingToken(true);
      localStorage.setItem("token", tokenUrl);
      reloadUserData().then(() => {
        navigate('/firehouse');
      });
    }
  }, [tokenUrl, navigate]);
  return (
    <>
      <img src='/images/main-login-img-new.png' className='d-none' onLoad={() => setWaitCssImg(false)} />
      <div className='main-login' style={{ visibility: waitCssImg ? 'hidden' : 'visible' }}>
        <div className='login-content-box'>
          <div className='login-content'>
            {!loadingToken &&
              <form onSubmit={handleSubmit(onSubmit)} className='login-width flex-grow-1 '>
                <div className='login-box'>
                  <Grid container rowSpacing={2} columnSpacing={{ xs: 12, sm: 2, md: 3 }}>
                    <Grid xs={12}>
                      <Box sx={{ my: 2 }} >
                        <img className='w-100 mb-3' src='/images/logo.svg' onClick={removeDepartment} style={{ cursor: 'pointer' }} />
                      </Box>
                      {!department && (
                        <TextFieldComponent
                          register={register('department', { required: "Department Address is required" })}
                          placeholder="Enter your department"
                          label="Department"
							            onChange={(e) => setTempDepartment(e.target.value)}
                          endAdornment={
                            <InputAdornment position="end">
                              <img src="/images/department.svg" alt="icon" style={{ marginRight: "5px" }} />
                            </InputAdornment>
                          }
                        />
                      )}
                      {errors.department && <p style={{ color: 'red' }}>{errors.department?.message}</p>}
                    </Grid>
                    <Grid xs={12}>
                      <TextFieldComponent
                        register={register('email', { required: "Username is required" })}
                        autoFocus
                        placeholder="Enter your Username"
                        label="Username"
                        endAdornment={
                          <InputAdornment position="end">
                            <img src="/images/user-name.svg" alt="icon" />
                          </InputAdornment>
                        }
                      />
                      {errors.email && <p style={{ color: 'red' }}>{errors.email?.message}</p>}
                    </Grid>
                    <Grid xs={12}>
                      <TextFieldComponent
                        register={register('password', { required: "Password is required" })}
                        placeholder="Enter your password"
                        label="Password"
                        type={showPassword ? 'text' : 'password'}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              onClick={togglePasswordVisibility}
                              style={{ marginRight: "-5px" }}
                              sx={{ color: 'white' }}
                              aria-label="toggle password visibility"
                            >
                              {showPassword ? <Visibility sx={{ color: 'white' }} /> : <VisibilityOff sx={{ color: 'white' }} />}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                      {errors.password && <p style={{ color: 'red' }}>{errors.password?.message}</p>}
                    </Grid>
                    <Grid xs={12}>
                      <Box sx={{ my: 2 }}>
                        <Button className='rounded-5 text-capitalize login-button' type='submit' fullWidth={true} variant="contained" color='error' disabled={loading}>
                          {loading ? 'Loading' : 'Login'}
                        </Button>
                      </Box>

                        <div className='rounded-5 text-capitalize login-button'
												style={{
													color: 'red',
													cursor: 'pointer',
													display: 'flex',
													justifyContent: 'end'
												}}
												onClick={() =>{
													if(department!=''){
										      localStorage.setItem("department", department);
													}
													if(tempDepartment!=''){
										      localStorage.setItem("department", tempDepartment);
													}
													navigate('/forgot-password')
													}}>
														Forgot Password
                        </div>
                    </Grid>
                  </Grid>
                </div>
              </form>
            }
            <Grid className='flex-grow-1 text-white d-flex align-items-end'>
              <p>
                Copyright <a className='textfeild_white' target='_blank' href='https://247software.cloud'>247software.cloud</a> 2023
              </p>
            </Grid>
          </div>
        </div>
      </div>
    </>
  );
}
